<template>
  <div class="nodeBox" :class="{ 'selectedBox': selected }">
    <div v-if="this.selected" id="toolbar">
      <!-- <BaseButton
        :text="'Add Tool'"
        :icon="ListPlus"
        :mode="'dark'"
        @click="suggestTool()"
      /> -->
      <BaseButton
        :text="'Suggest Tools'"
        :icon="ScanBarcode"
        :mode="'dark'"
        @click="suggestTool()"
      />
    </div>
    <Handle
      type="target"
      position="top"
      :style="{
        height: '10px',
        width: '10px',
        backgroundColor: 'white',
        border: 'thin solid #dadada',
      }"
    />
    <NodeHeader :title="data.label" :hook="''" />
    <div
      style="
        width: 100%;
        height: 1px;
        margin: 10px 0;
        background-color: #dadada;
      "
    ></div>
    <p>{{ data.text }}</p>
    <Handle
      type="source"
      position="bottom"
      :style="{
        height: '10px',
        width: '10px',
        backgroundColor: 'white',
        border: 'thin solid #dadada',
      }"
    />
  </div>
</template>

<script>
import { Handle } from "@vue-flow/core";
import NodeHeader from "./NodeComponents/NodeHeader.vue";
import BaseButton from "../buttons/BaseButton.vue";
import { ScanBarcode, ListPlus } from "lucide-vue-next";

export default {
  name: "BaseNode",
  props: {
    selected: Boolean,
    data: Object,
    id: String,
    // title: String,
    // text: String,
  },
  components: {
    NodeHeader,
    Handle,
    BaseButton,
  },
  methods: {
    toggleOptions() {
      this.toggledOptions = !this.toggledOptions;
    },
    async suggestTool() {
      this.$emit("updateNodeTool", this.id, this.data);
    },
  },
  data() {
    return {
      toggledOptions: false,
      ScanBarcode,
      ListPlus,
      // PenTool,
    };
  },
};
</script>

<style scoped>
.nodeBox {
  border: thin solid #dadada;
  border-radius: 7px;
  padding: 10px;
  background: white;
  max-width: 230px;
}
.nodeBox:hover {
  border: thin solid #721cff;
}
.nodeBox:active {
  box-shadow: 0 0 0 3px #ccadff;
}
.selectedBox {
  border: thin solid #721cff;
  box-shadow: 0 0 0 3px #ccadff;
}
.imgBox {
  height: 35px;
  width: 35px;
  background: #721cff10;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
}
#toolbar {
  position: absolute;
  background: #00000080;
  /* border: thin solid #721cff; */
  /* box-shadow: 0 0 0 3px #00000080; */
  transform: translate(-13px, -63px);
  padding: 6px;
  border-radius: 10px;
  display: flex;
}
</style>
